import { render, staticRenderFns } from "./ClassroomDetailTabMessageBoard.vue?vue&type=template&id=d44a90f0&scoped=true"
import script from "./ClassroomDetailTabMessageBoard.vue?vue&type=script&lang=js"
export * from "./ClassroomDetailTabMessageBoard.vue?vue&type=script&lang=js"
import style0 from "./ClassroomDetailTabMessageBoard.vue?vue&type=style&index=0&id=d44a90f0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d44a90f0",
  null
  
)

export default component.exports